import Modal from '../../../components/modal/Modal';
import Variables from '../../../style/variables.scss';
import Constants, {
  APARTMENT_GROUP,
  AVAILABILITY,
  BUILDING,
} from '../../../utils/Constants';
import { areasA, areasB } from '../data/InProgressBuildingPaths';
import { floors } from '../data/InProgressFloors';
import useInProgress from '../hooks/useInProgress';

const floorsImgsA = require.context(
  '../../../assets/imgs/inProgress/buildingsSections/building_a',
  true
);
const floorsImgsAList: Array<string> = floorsImgsA
  .keys()
  .map((image: string) => floorsImgsA(image));

const floorsImgsB = require.context(
  '../../../assets/imgs/inProgress/buildingsSections/building_b',
  true
);
const floorsImgsBList: Array<string> = floorsImgsB
  .keys()
  .map((image: string) => floorsImgsB(image));

const InProgressBuildingModal = ({
  selectedFloor,
  openActiveApartmentModal,
  handleFloorFilter,
  filteredApartments,
  openModal,
  closeModal,
}: {
  selectedFloor: string | null;
  openActiveApartmentModal: (apartmentId: string) => void;
  handleFloorFilter: (floor: string | null) => void;
  filteredApartments: Apartment[] | null;
  openModal: boolean;
  closeModal: () => void;
}) => {
  const { hoveredArea, setHoveredArea } = useInProgress();

  const handleFloorSelection = (direction: 'down' | 'up') => {
    if (selectedFloor !== null) {
      const currentFloor = floors.find((floor) => floor.name === selectedFloor);

      if (!currentFloor) return;

      if (direction === 'down') {
        if (currentFloor.index > 1) {
          handleFloorFilter(floors[currentFloor.index - 2].name);
        }
      }

      if (direction === 'up') {
        if (currentFloor.index < floors.length) {
          handleFloorFilter(floors[currentFloor.index].name);
        }
      }
    }
  };

  const findApartmentAvailability = (name: string) => {
    if (filteredApartments !== null) {
      let filter = filteredApartments.find(
        (apt) => apt.building + apt.apartmentNumber === name
      )?.availability;

      if (filter) {
        return filter;
      }
      return null;
    }
  };

  return (
    <Modal
      id='building_modal'
      isOpen={openModal}
      onClose={closeModal}
      primaryColor={Variables.primaryColor}
      secondaryColor={Variables.secondaryColor}
    >
      {filteredApartments && filteredApartments.length > 0 && (
        <div className='inprogress_page_building_modal'>
          <div className='inprogress_page_building_modal_select'>
            <div
              className='opacity_transition_low'
              onClick={() => handleFloorSelection('down')}
            >
              {Constants.arrowLeft(Variables.secondaryColor)}
            </div>
            <div
              className='opacity_transition_low'
              onClick={() => handleFloorSelection('up')}
            >
              {Constants.arrowRight(Variables.secondaryColor)}
            </div>
            <div>
              <h3>
                {
                  floors.find((floor) =>
                    floor.name.includes(selectedFloor ? selectedFloor : '')
                  )?.title
                }
              </h3>
            </div>
          </div>
          <h2 className='text_center'>
            {`ZGRADA ${
              filteredApartments[0].building === BUILDING.C
                ? BUILDING.B
                : filteredApartments[0].building
            }`}
          </h2>
          <div className='inprogress_page_building_modal_plan'>
            <svg
              viewBox='0 0 1920 1080'
              xmlns='http://www.w3.org/2000/svg'
              width={1440}
              height={700}
            >
              <image
                href={
                  filteredApartments[0].building === BUILDING.A
                    ? floorsImgsAList.find((img) =>
                        img.includes(
                          selectedFloor !== null
                            ? selectedFloor !== APARTMENT_GROUP.GROUND &&
                              selectedFloor !== APARTMENT_GROUP.SUPERSTRUCTURE
                              ? 'floor'
                              : selectedFloor
                            : ''
                        )
                      )
                    : floorsImgsBList.find((img) =>
                        img.includes(
                          selectedFloor !== null
                            ? selectedFloor === APARTMENT_GROUP.FLOOR_ONE
                              ? 'one'
                              : selectedFloor !== APARTMENT_GROUP.GROUND &&
                                selectedFloor !== APARTMENT_GROUP.SUPERSTRUCTURE
                              ? 'floor'
                              : selectedFloor
                            : ''
                        )
                      )
                }
                width='100%'
                height='100%'
                preserveAspectRatio='xMidYMid slice'
              />
              {filteredApartments[0].building === BUILDING.A
                ? areasA
                    .find((area) =>
                      selectedFloor !== null ? area.floor === selectedFloor : ''
                    )
                    ?.apartments?.map((apartment, index) => (
                      <polygon
                        key={apartment.name + index}
                        points={apartment.coords}
                        fill={
                          findApartmentAvailability(apartment.name) ===
                          AVAILABILITY.RESERVED
                            ? `${Variables.reserved}66`
                            : findApartmentAvailability(apartment.name) ===
                              AVAILABILITY.SOLD
                            ? `${Variables.sold}66`
                            : hoveredArea === apartment.name
                            ? '#00000066'
                            : '#00000000'
                        }
                        onMouseEnter={() => {
                          setHoveredArea(apartment.name);
                        }}
                        onMouseLeave={() => {
                          setHoveredArea(null);
                        }}
                        onClick={() => openActiveApartmentModal(apartment.name)}
                      />
                    ))
                : areasB
                    .find((area) =>
                      selectedFloor !== null ? area.floor === selectedFloor : ''
                    )
                    ?.apartments?.map((apartment, index) => (
                      <polygon
                        key={apartment.name + index}
                        points={apartment.coords}
                        fill={
                          hoveredArea === apartment.name
                            ? '#00000066'
                            : '#00000000'
                        }
                        onMouseEnter={() => {
                          setHoveredArea(apartment.name);
                        }}
                        onMouseLeave={() => {
                          setHoveredArea(null);
                        }}
                        onClick={() => openActiveApartmentModal(apartment.name)}
                      />
                    ))}
            </svg>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default InProgressBuildingModal;
